import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Grid, Type } from '../../../app/StyleGuide';
import {
  Card,
  CardPoster,
  InlineList,
  SixteenNineAspectRatioPlaceholder,
  InlineDotLoadingAnimation,
} from '../../../components/Layout';
import { SmallTransparentRoundedIconButton } from '../../../components/Buttons';
import VideoService from '../../../services/VideoService';
import { Material } from '../models/material';

const Details = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 0 ${Grid._4} ${Grid._4} ${Grid._4};
  text-transform: capitalize;
  color: ${Type.Color.dark};
  h4 {
    margin: ${Grid._4} 0 ${Grid._4} 0;
  }
`;

const NameHeader = styled(Details)`
  flex-direction: row;
  padding: 0;
`;

const PosterPlaceholder = () => (
  <SixteenNineAspectRatioPlaceholder borderRadius="4px 4px 0 0">
    <InlineDotLoadingAnimation />
  </SixteenNineAspectRatioPlaceholder>
);
export default function BibleStudyVideoCard({
  video,
  redirectToMaterial,
}: {
  video: Material;
  redirectToMaterial: (value: string) => void;
}) {
  const [poster, setPoster] = useState();

  useEffect(() => {
    VideoService.getPoster(video.mediaId)
      .then(response => setPoster(response))
      .catch(err => console.error(err));
  }, []);

  const downloadFile = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    const downloadUrl = `${window.getApiUrl()}/curriculum-storage/downloadvideo/${video.mediaId}`;
    window.open(downloadUrl);
  };

  return (
    <Card style={{ flexDirection: 'column' }} onClick={() => redirectToMaterial(video.materialId)}>
      {poster ? <CardPoster src={poster}></CardPoster> : <PosterPlaceholder />}
      <Details>
        <NameHeader>
          <h4>{video.name}</h4>
          <SmallTransparentRoundedIconButton onClick={e => downloadFile(e)}>
            <i className="fas fa-download fa-fw"></i>
          </SmallTransparentRoundedIconButton>
        </NameHeader>
        <InlineList content={'•'}>
          {video && video.series && video.series.map(c => <li key={c.collectionId}>{c.name}</li>)}
        </InlineList>
      </Details>
    </Card>
  );
}
